import { put, takeLatest } from 'redux-saga/effects';

import { requestBrokerFirms, requestCreateBrokerFirms, requestUpdateBrokerFirms } from '../../services/broker';
import {
    createBrokerFirmsFailure,
    createBrokerFirmsSuccess,
    deleteBrokerFirmsFailure,
    deleteBrokerFirmsSuccess,
    fetchBrokerFirmsFailure,
    fetchBrokerFirmsSuccess,
    updateBrokerFirmsFailure,
    updateBrokerFirmsSuccess
} from '../actions/broker/brokerFirm';
import {
    CREATE_BROKER_FIRM_REQUEST,
    DELETE_BROKER_FIRM_REQUEST,
    FETCH_BROKER_FIRMS_REQUEST,
    UPDATE_BROKER_FIRM_REQUEST
} from '../actions/broker/types';

export function* watchBrokerFirmSaga() {
    yield takeLatest(FETCH_BROKER_FIRMS_REQUEST, fetchBrokerFirms);
    yield takeLatest(CREATE_BROKER_FIRM_REQUEST, createBrokerFirm);
    yield takeLatest(UPDATE_BROKER_FIRM_REQUEST, updateBrokerFirm);
    yield takeLatest(DELETE_BROKER_FIRM_REQUEST, deleteBrokerFirm);
}

/**
 * @typedef {Object} PAYLOAD
 * @property {number} skip
 *
 * @typedef {Object} PARAMS
 * @property {PAYLOAD} payload
 *
 */

/**
 *
 * @param {PARAMS} param0
 */
function* fetchBrokerFirms({ payload }) {
    try {
        /**
         * @type {FetchBrokerFirmsResponse}
         */
        const response = yield requestBrokerFirms(payload);
        yield put(fetchBrokerFirmsSuccess(response));
    } catch (error) {
        yield put(
            fetchBrokerFirmsFailure('Failed to get list of broker firms')
        );
    }
}

/**
 *
 * @param {PARAMS} param0
 */
function* createBrokerFirm({ payload }) {
    try {
        const response = yield requestCreateBrokerFirms(payload);
        yield put(createBrokerFirmsSuccess(response.data));
    } catch (error) {
        const message =
          error.response?.data?.data || "Unknown Error";
        yield put(
            createBrokerFirmsFailure(message)
        );
    }
}

/**
 *
 * @typedef {Object} BrokerFirmUpdatePayload
 * @property {BrokerFirm} payload
 *
 * @param {BrokerFirmUpdatePayload} param0
 */
function* updateBrokerFirm({ payload }) {
    try {
        const response = yield requestUpdateBrokerFirms(payload);
        yield put(updateBrokerFirmsSuccess(response.data));
    } catch (error) {
        yield put(
            updateBrokerFirmsFailure('Failed to get list of broker firms')
        );
    }
}

/**
 *
 * @param {PARAMS} param0
 */
function* deleteBrokerFirm({ payload }) {
    try {
        const data = yield deleteBrokerFirm(payload);
        yield put(deleteBrokerFirmsSuccess(data));
    } catch (error) {
        yield put(
            deleteBrokerFirmsFailure('Failed to get list of broker firms')
        );
    }
}
